import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import { CdkTableModule } from '@angular/cdk/table';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbPaginationModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { TableComponent } from './table.component';
import { SortModule } from './sort/sort.module';
import { TableTopComponent } from './table-top/table-top.component';
import { ButtonHideShowComponent } from './table-top/button-hide-show/button-hide-show.component';
import { EditLinkComponent } from './row-components/edit-link/edit-link.component';
import { DeleteButtonComponent } from './row-components/delete-button/delete-button.component';
import { EllipsisComponent } from './row-components/ellipsis/ellipsis.component';
import { ButtonFilterComponent } from './table-top/button-filter/button-filter.component';
import { TableFilterComponent } from './table-top/table-filter/table-filter.component';
import { ButtonResetFilterComponent } from './table-top/button-reset-filter/button-reset-filter.component';
import { TableTopTooltipComponent } from './table-top-tooltip/table-top-tooltip.component';

@NgModule({
	declarations: [ 
		TableComponent
		, TableTopComponent
		, ButtonHideShowComponent
		, EditLinkComponent
		, DeleteButtonComponent
		, EllipsisComponent
		, ButtonFilterComponent
		, TableFilterComponent
		, ButtonResetFilterComponent
		, TableTopTooltipComponent
	],
	imports: [
		CommonModule
		, FormsModule
		, RouterModule
		, NgbPaginationModule
		, SortModule
		, NgbTooltipModule
		, MatTableModule
		, CdkTableModule
		, FontAwesomeModule
	],
	exports: [ 
		TableComponent
		, MatTableModule
		, CdkTableModule
		, SortModule
		, EditLinkComponent
		, DeleteButtonComponent
		, EllipsisComponent
		, TableFilterComponent
		, TableTopTooltipComponent
	]
})
export class TableModule { }